import dayjs from "dayjs";

import httpManager from "@/app/shared/utils/httpManager";
import {
  ReportTypes,
  PayPromiseReportTypes,
  PayPromiseReportTypesNames,
} from "@/app/reports/utils/enums";

export async function downloadProgress({ filters } = {}) {
  const filterDate = dayjs(filters.date);
  const startDate = filterDate.subtract(1, "day").format("YYYY-MM-DD");
  const endDate = filterDate.add(1, "day").format("YYYY-MM-DD");

  let query = "";
  if (filters.entity) query += `entity=${filters.entity}&`;
  query += `portfolio=${filters.portfolio}&`;
  if (filters.base) query += `base=${filters.base}&`;
  query += `start_date=${startDate}&`;
  query += `end_date=${endDate}`;

  const pdp_type = PayPromiseReportTypesNames[PayPromiseReportTypes.Progress];

  const url = `/reports/${ReportTypes.PayPromise}/download/?pdp_type=${pdp_type}&${query}`;

  const response = await httpManager.post(url, {}, { blob: true });
  return response;
}
